import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class SonarQube extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M21.2198496,23.2234586 L19.8796992,23.2234586 C19.8796992,12.4348872 10.9774436,3.65774436 0.0354887218,3.65774436 L0.0354887218,2.31759398 C11.7166917,2.31759398 21.2198496,11.6956391 21.2198496,23.2234586 Z"></path>
        <path d="M22.1461654,16.0288722 C20.5371429,9.26315789 15.0538346,3.60902256 8.18045113,1.63609023 L8.48842105,0.563007519 C15.7431579,2.64661654 21.5338346,8.61533835 23.2324812,15.7708271 L22.1461654,16.0288722 Z"></path>
        <path d="M23.1765414,9.67639098 C21.5193985,6.06255639 18.6959398,2.9118797 15.2264662,0.803609023 L15.6908271,0.0396992481 C19.3112782,2.24 22.2580451,5.52962406 23.9915789,9.30285714 L23.1765414,9.67639098 Z"></path>
      </svg>
    );
  }
}

export default SonarQube;
